import { DataPointTreeItem } from 'src/pages/SignInPage/_BLL/types';
import { db } from '../init';

export const addDataPointTree = async (dataPointTree: DataPointTreeItem[]) => {
	try {
		await db.dataPointTree.bulkAdd(dataPointTree);
	} catch (error) {
		console.log(error);
	}
};
